import styled from "@emotion/styled";
import { DatePicker, TimePicker } from "@kaltura/ds-react-components";
import { fullWidthFlexItemStyles } from "@kaltura/mediaspace-shared-utils";

export const StyledPickersUnitWrapper = styled("div")(({ theme }) => ({
    ...fullWidthFlexItemStyles,
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        width: "100%",
    },
}));

export const StyledPickersWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        width: "100%",
        justifyContent: "space-between",
    },
}));

export const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
    ...fullWidthFlexItemStyles,
    // Date picker is slightly wider than time picker on desktop
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        flexBasis: "55%",
    },
}));
export const StyledTimePicker = styled(TimePicker)(({ theme }) => ({
    ...fullWidthFlexItemStyles,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        flexBasis: "45%",
    },
}));
